import { getStore } from '../Store'

export enum TriggerActionType {
    POKER_GAME_EXITED = 'POKER_GAME_EXITED',
    CASINO_GAME_EXITED = 'CASINO_GAME_EXITED',
    CASHIER_MODAL_OPENED = 'CASHIER_MODAL_OPENED'
}

export type TriggerAction =
    | { type: TriggerActionType.POKER_GAME_EXITED }
    | { type: TriggerActionType.CASINO_GAME_EXITED }
    | { type: TriggerActionType.CASHIER_MODAL_OPENED }

export const dispatchTriggerAction = (action: TriggerAction) => getStore().dispatch(action)

export const dispatchPokerGameExited = () => dispatchTriggerAction({ type: TriggerActionType.POKER_GAME_EXITED })

export const dispatchCasinoGameExited = () => dispatchTriggerAction({ type: TriggerActionType.CASINO_GAME_EXITED })

export const dispatchCashierModalOpened = () => dispatchTriggerAction( { type: TriggerActionType.CASHIER_MODAL_OPENED })
